/**
 * 로그인 없이 열리는 화면의 주소 머리(2026-10-30). KOL 이 링크로 여는 영상 피드백 페이지.
 * 앱 시작 때 부르는 요청(환율 등)이 로그인 없이 401 을 받아도, 이 주소에서는 로그인 화면으로 보내지 않는다
 * (보내면 KOL 이 링크를 열어도 로그인 화면이 떴다 — 배포 뒤 점검에서 발견).
 * 2026-11-04: 시딩 신청 화면(/seed, /seed/:slug) — KOL(신청자)은 직원 로그인이 아니라 별도 신청자 로그인을 쓴다.
 */
export const PUBLIC_PATH_PREFIXES = ['/kol-draft/', '/seed/'];
/** 접두어가 아니라 이 주소 «그대로»일 때만 공개인 화면 */
export const PUBLIC_EXACT_PATHS = ['/seed', '/privacy']; // /privacy = 시딩 신청용 개인정보처리방침(2026-11-04)

export const isPublicPath = (pathname) => {
  const p = String(pathname || '');
  return PUBLIC_EXACT_PATHS.includes(p) || PUBLIC_PATH_PREFIXES.some((x) => p.startsWith(x));
};
